import { get } from '@/api/request';

function fetchLogs(params) {
  return get('/logs', params);
}

function fetchTimeLogLogs({ timeLogId }) {
  return get(`/time_logs/${timeLogId}/logs`);
}

export default {
  fetchLogs,
  fetchTimeLogLogs,
};



// WEBPACK FOOTER //
// ./src/store/modules/log/api.js